module.exports = __webpack_public_path__ + "static/img/img_title_en.e69a2e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newYear-2023/img_title_en.png
// module id = 3Jsh
// module chunks = 1